import {RouteDefinition} from '../../../routes';
import {AlarmEditScreen} from './AlarmEditScreen';

export const AlarmSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/alarm',
        component: AlarmEditScreen,
    },
];
